import { render, staticRenderFns } from "./HomeWishlistEN.vue?vue&type=template&id=56b41868&scoped=true"
import script from "./HomeWishlistEN.vue?vue&type=script&lang=js"
export * from "./HomeWishlistEN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b41868",
  null
  
)

export default component.exports